import { useState } from 'react';
import { AxiosError, AxiosResponse } from 'axios';
import useToast from 'hooks/useToast';
import { useQRScreenNavigation } from 'hooks/navigation/useQRSCreenNavigation';
import { useVerifyGuestOTPMutation } from '../api/mutations';
import { useQRStore } from '../store/useQRStore';
import { useQRFlow } from './useQRFlow';

export const useVerifyOTPCode = () => {
  const {
    dataFromURL,
    mobileNumber,
    codeToVerify,
    setCodeToVerify,
    setUserDetail,
  } = useQRStore();
  const [error, setError] = useState('');
  const toast = useToast();
  const {
    goToInfoCollection,
    goToVariconUserDetail,
    goToGuestUserDetail,
    goToVariconEmployeeDetail,
  } = useQRScreenNavigation();
  const { setItemsToLocalStorage } = useQRFlow();

  const validateOTPCode = (value: string) => {
    if (!value) {
      setError('OTP is required');
      return false;
    }
    if (value.length !== 4) {
      setError('OTP must be 4 digits');
      return false;
    }
    if (!Number.isInteger(Number(value))) {
      setError('OTP must be a number');
      return false;
    }
    setError('');
    return true;
  };
  const { tenantID } = dataFromURL ?? {};

  const { mutate: verifyOTP, isPending: verifyOTPLoading } =
    useVerifyGuestOTPMutation({
      onSuccess: (res: AxiosResponse) => {
        const responseMessage = res?.data?.message;
        const userType = res?.data?.user_type;
        setCodeToVerify('');
        toast.success(responseMessage ?? 'OTP verified successfully');
        if (userType === 'new_guest') {
          goToInfoCollection();
        } else if (userType === 'guest') {
          setItemsToLocalStorage(res?.data);
          setUserDetail(res?.data?.user_detail);
          goToGuestUserDetail();
        } else if (userType === 'employee') {
          setUserDetail(res?.data?.user_detail);
          goToVariconEmployeeDetail();
        } else {
          setItemsToLocalStorage(res?.data);
          setUserDetail(res?.data?.user_detail);
          goToVariconUserDetail();
        }
      },
      onError: (err: AxiosError) => {
        const errorMessage = (err?.response?.data as { message: string })
          ?.message;
        if (errorMessage) {
          toast.error(errorMessage);
        } else {
          toast.error('Error occurred. Please try again later');
        }
      },
    });

  const handleVerifyOTP = () => {
    if (!validateOTPCode(codeToVerify)) return;
    verifyOTP({
      phone_number: mobileNumber,
      otp_code: codeToVerify,
      tenant_id: tenantID ?? '',
    });
  };

  return { verifyOTPLoading, handleVerifyOTP, error };
};
